import React, { useState, useEffect } from 'react';
import QueryForm from '../../components/QueryForm/QueryForm';
import InfoCard from '../../components/InfoCard/InfoCard';
import { useScreenSize } from '../../hooks/useScreenSize';
import { chatApi } from '../../api/chat';
import './Dashboard.scss';

function Dashboard() {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const { isMobile, isTablet } = useScreenSize();
  const isSmallScreen = isMobile || isTablet || window.innerWidth <= 1024;
  const [chats, setChats] = useState([]);
  const [selectedChatId, setSelectedChatId] = useState(null);

  useEffect(() => {
    const fetchChatRooms = async () => {
      const rooms = await chatApi.getChatRooms();
      if (rooms.length > 0) {
        setChats(rooms);
        setSelectedChatId(rooms[0].id);
      }
    };
    fetchChatRooms();

  }, []);

  const handleNewChat = async () => {
    const newChat = await chatApi.createChatRoom();
    setChats([newChat,...chats]);
    setSelectedChatId(newChat.id);
  };

  const quickTips = [
    "Be specific with your questions",
    "Include relevant medical history",
    "Mention any current medications",
    "Describe symptoms clearly"
  ];

  const importantNotice = 
    "This service is not a substitute for professional medical care. For emergencies, please call your local emergency services or visit the nearest hospital.";

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const closeSidebar = () => {
    setIsSidebarOpen(false);
  };

  const handleChatClick = (chatId) => {
    setSelectedChatId(chatId);
  };

  const handleTitleChange = (chatId, newTitle) => {
    setChats(prevChats => 
      prevChats.map(chat => 
        chat.id === chatId 
          ? { ...chat, name: newTitle }
          : chat
      )
    );
  };

  return (
    <div className="dashboard">
      {isSmallScreen && !isSidebarOpen && (
        <button className="dashboard__toggle-sidebar" onClick={toggleSidebar}>
          <span className="dashboard__toggle-icon">+</span>
        </button>
      )}

      <aside className={`dashboard__sidebar ${isSmallScreen ? 'mobile' : ''} ${isSidebarOpen ? 'open' : ''}`}>
        {isSidebarOpen && (
          <button className="dashboard__back-button" onClick={closeSidebar}>
            &#8592;
          </button>
        )}
        <button className="dashboard__new-chat" onClick={handleNewChat}>
          + New Chat
        </button>
        <h3>Chat History</h3>
        <div className="dashboard__chat-history">
          {chats.map((chat, index) => (
            <div key={index} className="dashboard__chat-item" onClick={() => handleChatClick(chat.id)}>
              <span className="dashboard__chat-title">{chat.name}</span>
              <span className="dashboard__chat-date">{chat.created_at}</span>
            </div>
          ))}
        </div>
      </aside>

      {selectedChatId && (
        <QueryForm 
          roomId={selectedChatId} 
          onTitleChange={(newTitle) => handleTitleChange(selectedChatId, newTitle)} 
        />
      )}


      {!isSmallScreen && selectedChatId && (
        <aside className="dashboard__info-sidebar">
          <InfoCard 
            title="Quick Tips" 
            items={quickTips} 
          />
          <InfoCard 
            title="Important Notice" 
            notice={importantNotice}
          />
        </aside>
      )}
    </div>
  );
}

export default Dashboard; 